// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1RpCa","unreadBadge":"styles_unreadBadge__2cA-3","modalContent":"styles_modalContent__39uzt","modal":"styles_modal__1U_2H"};